require('./tasks.style.scss');

const jobsModule = angular.module('com.comtrade.azureCloud.backup.jobs', []);

jobsModule.component('jobs', require('./tasks.component'));
jobsModule.component('reportDialog', require('./dialogs/reportDialog/reportDialog.component'));

jobsModule.service('tasksPersistence', require('./tasks.persistence.service'));

module.exports = jobsModule;



// WEBPACK FOOTER //
// ./src/azurebackup/views/tasks/tasks.module.js